import React, { useContext, useRef } from "react";
import styled from "styled-components";
import { SimpleTooltip, Button } from "simple-ui-components";

import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SyncAltIcon from "@mui/icons-material/SyncAlt";

import { AuthContext } from "../authContextProvider";
import {
  BodyWrapperStyled,
  BoxStyled,
  CardStyled,
  CardHeader,
  CardBody,
} from "../../theme";
import { ChangePassword } from "./changePassword";
import EditAccountName from "./editAccountName";
import { UploadLogo } from "./uploadLogo";
import { get } from "../../server-requests/serverRequests";
import EditCompanyName from "./editCompanyName";
import { getTranslation, LanguageContext } from "../languageProvider";
import { Log } from "../shared/utility";
import { Layout } from "../layout/otherPage";

export const Profile = () => {
  const changePasswordRef = useRef();
  const editAccountNameRef = useRef();
  const editCompanyNameRef = useRef();

  const { Tooltip } = SimpleTooltip;

  const { appUser, setAppUser, snackbarHandler } = useContext(AuthContext);
  const { lang } = useContext(LanguageContext);

  const changePasswordClickHandler = () =>
    changePasswordRef.current.ChangePassword();

  const editAccountNameClickHandler = () =>
    editAccountNameRef.current.AccountInformation(appUser);

  const editCompanyNameClickHandler = () =>
    editCompanyNameRef.current.CompanyInformation(appUser);

  const updateUserInformation = () => {
    // get user information
    get("accounts")
      .then((user) => setAppUser(user))
      .catch((status) => {
        snackbarHandler(getTranslation(`error${status}`));
        Log("updateTokenListener -> error", status);
      });
  };

  return (
    <Layout lang={lang}>
      <div style={{ height: "100%" }}>
        <BodyWrapperStyled fullHeight>
          <BoxStyled width="md" col="2">
            <CardStyled>
              <CardHeader>
                <PermIdentityIcon className="mainIcon" />
                <div className="detail" data-translate="0034">
                  {getTranslation("0034")}
                </div>
              </CardHeader>
              <CardBody height={"Full"}>
                {appUser && (
                  <ProfileDetail>
                    <h2 data-translate="0049">{getTranslation("0049")}</h2>
                    <AccountDetailStyled>
                      <div>
                        <span data-translate="0050">
                          {getTranslation("0050")}
                        </span>
                        <span className="userInformation">{appUser.name}</span>
                        <Tooltip text={getTranslation("0070")} placement="left">
                          <EditOutlinedIcon
                            onClick={editAccountNameClickHandler}
                          />
                        </Tooltip>
                      </div>
                      <div>
                        <span data-translate="0002">
                          {getTranslation("0002")}
                        </span>
                        <span className="userInformation">{appUser.email}</span>
                      </div>
                      <div>
                        <span data-translate="0052">
                          {getTranslation("0052")}
                        </span>
                        <span className="userInformation">
                          {appUser.company && appUser.company.name}
                          <span>
                            {appUser.role && appUser.role.description}
                          </span>
                        </span>
                        <Tooltip text={getTranslation("0070")} placement="left">
                          <EditOutlinedIcon
                            onClick={editCompanyNameClickHandler}
                          />
                        </Tooltip>
                      </div>
                    </AccountDetailStyled>
                  </ProfileDetail>
                )}
                <ProfileDetail>
                  <h2 data-translate="0148">{getTranslation("0148")}</h2>
                  {appUser && appUser.company && appUser.company.logo && (
                    <div>
                      <img
                        src={appUser.company && appUser.company.logo}
                        alt={appUser.company && appUser.company.name}
                        className="logo"
                      />
                    </div>
                  )}
                  <div>
                    <UploadLogo Success={updateUserInformation} />
                  </div>
                </ProfileDetail>
                <ProfileDetail>
                  <h2 data-translate="0053">{getTranslation("0053")}</h2>
                  <div>
                    <Button
                      theme="default"
                      type="button"
                      clicked={changePasswordClickHandler}
                      icon={<SyncAltIcon />}
                      className="btn-secondary"
                      text={getTranslation("0053")}
                    />
                  </div>
                </ProfileDetail>
              </CardBody>
            </CardStyled>
          </BoxStyled>
        </BodyWrapperStyled>
        <ChangePassword ref={changePasswordRef} />
        <EditAccountName
          ref={editAccountNameRef}
          UpdateSuccess={updateUserInformation}
        />
        <EditCompanyName
          ref={editCompanyNameRef}
          UpdateSuccess={updateUserInformation}
        />
      </div>
    </Layout>
  );
};

const AccountDetailStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    display:flex;
    flex-direction:column;
    >div{
      margin-bottom:${current.gMD};
      display:flex;
      >span:first-child{
        flex-basis:120px;
        margin-right:${current.gMD};
        color:rgba(${current.black},0.3);
      }
      >span.userInformation{
        flex-grow:1;
        display:flex;
        flex-direction:column;
        >span{
        color:rgba(${current.black},0.3);
        }
      }
      svg{
        align-self: stretch;
        ${current.fXL};
        cursor:pointer;
        color:rgba(${current.black},0.3);
        margin-bottom: -4px;
        :hover{
          color:rgba(${current.cOne});
        }
      }
    }
  `;
  }}
`;

const ProfileDetail = styled.section`
  ${(props) => {
    let current = props.theme;
    return `
      display:flex;
      flex-direction:column;
      padding:${current.gMD};
      border-bottom:1px solid rgba(${current.black},0.0625);
      >h2{
        ${current.fDF};
        color:rgb(${current.cOne});
        margin-bottom:${current.gLG};
        display:flex;
        justify-content: space-between;
        align-items: center;
      }
      .logo{
        width:290px;
      }
    `;
  }}
`;
